import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        tickets: {
            data: [],
            current_page: 1, total: 0, per_page: 10
        },
        ticket: [],
        loading: false,
        errors: {
            data: {
                errors: {
                    tenant_id: [],
                    ticket_category_id: [],
                    ticket_status_id: [],
                    ticket_channel_id: [],
                    email: [],
                    full_name: [],
                    id_number: [],
                    phone_number: [],
                    description: [],
                    comments: [],
                }
            }
        },
        has_errors: false,
        downloading_tickets: false,
        sending_ticket_comment: false
    },
    getters: {
        ticket: state => state.ticket,
        tickets: state => state.tickets,
        loading: state => state.loading,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        downloading_tickets: state => state.downloading_tickets,
        sending_ticket_comment: state => state.sending_ticket_comment,
    },
    mutations: {
        setSendingTicketComment(state, val) {
            state.sending_ticket_comment = val
        },
        setDownloadingLoading(state, val) {
            state.downloading_tickets = val
        },
        setLoading(state, val) {
            state.loading = val
        },
        setTickets(state, data) {
            state.tickets = data;
        },
        setTicket(state, data) {
            state.ticket = data;
        }, setErrors(state, errors) {
            state.errors = errors
        }, hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            tenant_id: [],
                            ticket_category_id: [],
                            ticket_status_id: [],
                            ticket_channel_id: [],
                            email: [],
                            full_name: [],
                            id_number: [],
                            phone_number: [],
                            description: [],
                            comments: []
                        }
                    }
                };
            }
        }
    }, actions: {
        async getTenantTickets({commit}, filters) {
            try {
                commit('activateLoading', 'ticket/list', {root: true});
                const response = await api.getTenantTickets(filters);
                commit('setTickets', response);
                commit('deactivateLoading', 'ticket/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getTickets({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'ticket/list', {root: true});
                const response = await api.getTickets(filters);
                commit('setTickets', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'ticket/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getTicket({commit}, id) {
            try {
                commit('activateLoading', 'ticket/list', {root: true});
                const response = await api.getTicket(id);
                commit('setTicket', response.data);
                commit('deactivateLoading', 'ticket/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async updateTicketActions({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.updateTicketActions(data);
                dispatch('getTicket', data.ticket_id)
                ElMessage.success('Ticket update successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error updating Ticket!');
            }
        },

        async createTenantTickets({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createTenantTickets(data);
                dispatch('getTenantTickets', {
                    paginate: true
                })
                ElMessage.success('Ticket created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating Ticket!');
            }
        },
        async sendComment({dispatch, commit}, data) {
            try {
                commit('setSendingTicketComment', true)
                commit('hasErrors', false)
                await api.sendComment(data);
                dispatch('getTicket', data.get('ticket_id'))
                ElMessage.success('comments added successfully!');
                commit('setSendingTicketComment', false)
            } catch (e) {
                commit('setSendingTicketComment', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error adding comment!');
            }
        },
        async sendCommentAdmin({dispatch, commit}, data) {
            try {
                commit('setSendingTicketComment', true)
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.sendCommentAdmin(data);
                dispatch('getTicket', data.ticket_id)
                ElMessage.success('Comments added successfully!');
                commit('setSendingTicketComment', false)
                commit('setLoading', false)
            } catch (e) {
                commit('setSendingTicketComment', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                commit('setLoading', false)
                ElMessage.error('Error adding comment!');
            }
        },
        async createTickets({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createTicket(data);
                dispatch('getTickets', {
                    paginate: true
                })
                commit('setLoading', false)
                ElMessage.success('Ticket created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                commit('setLoading', false)
                ElMessage.error('Error creating Ticket!');
            }
        },

        async editTicket({dispatch}, data) {
            try {
                await api.editTicket(data);
                dispatch('getTickets', data.id);
                ElMessage.success('Ticket updated successfully!');
            } catch (e) {
                ElMessage.error('Error updating Ticket');
            }
        },

        async editTicketFormData({dispatch}, data) {
            try {
                await api.editTicketFormData(data);
                dispatch('getTickets', data.id);
                ElMessage.success('Ticket updated successfully!');
            } catch (e) {
                ElMessage.error('Error updating Ticket');
            }
        },

        async deleteTicket({dispatch}, data) {
            try {
                await api.deleteTicket(data);
                dispatch('getTickets', data.id);
                ElMessage.success('Ticket removed successfully!');
            } catch (e) {
                ElMessage.error('Error removing Ticket');
            }
        },

        async downloadTicketHistory({commit}, filters) {
            try {
                commit('setDownloadingLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();

                const response = await api.downloadTicketHistory(filters);
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Tickets_' + fileName + '.xlsx');
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingLoading', false);
            } catch (e) {
                commit('setDownloadingLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

        async exportTicketsReport({commit}, {filters, format}) {
            try {
                commit('setDownloadingLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportTicketsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Tickets_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingLoading', false);
            } catch (e) {
                commit('setDownloadingLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }

    }
}
